import { actions, selectors } from '../../state';

export class StepsService {
  constructor($rootScope, updStore) {
    'ngInject';
    const { getState } = updStore;

    Object.assign(this, {
      $rootScope,
      updStore,
    });
  }

  init() {
    this._listener = this.$rootScope.$on('$stateChangeSuccess', () => {
      const { dispatch, getState } = this.updStore;
      const state = getState();
      const isSingleton = selectors.router.currentDataMoveItemSingleton(state);
      const move = selectors.current.move(state);
      const moveId = move.id(state);

      // With JSON-API we changed from `type` to `kind` which is why
      // there is a mismatch here.
      // TODO: Go through each step and change from `moveItem.type` to `moveItem.kind`
      const kind = selectors.router.currentDataMoveItemType(state);

      const doesItemExist = selectors.current.hasItemByKind(kind, state);

      if (isSingleton && !doesItemExist) {
        dispatch(actions.item.create({ move_id: moveId, kind }));
      }

      dispatch(actions.step.setCurrent(kind));
    });
  }

  destroy() {
    // TODO: Determine how/what to clean up
    this.updStore.dispatch(actions.step.clearCurrent());
    this._listener();
  }
}
